/* eslint-disable no-plusplus */
import validator from 'validator';
import storage from 'store';
import Cookies from 'js-cookie';
import accounting from 'accounting';

export class Helper {
  static scrollTop() {
    document.querySelector('main').scrollTo(0, 0);
  }

  static getParameterByName(name, url) {
    // eslint-disable-next-line no-param-reassign
    if (!url) url = window.location.href;
    // eslint-disable-next-line no-param-reassign
    name = name.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  static setLoginInfo() {
    storage.set('isLeavePrint', 1);
  }

  static getLoginInfo() {
    return storage.get('isLeavePrint');
  }

  static removeLoginInfo() {
    storage.remove('isLeavePrint');
    Cookies.remove('eBusinessToken', {
      domain: '.qq.com',
    });
  }

  // 倒计时执行函数
  static waitTime(time = 60, process = () => {}, complete = () => {}) {
    // eslint-disable-next-line func-names
    (function () {
      let grand = time;
      function wait() {
        grand--;
        if (grand > 0) {
          process(grand);
          setTimeout(wait, 1000);
        } else {
          complete();
        }
      }

      wait();
    }());
  }

  // 判断字符是否是汉字
  static isChinese(temp) {
    const regex = /(?:[\u3400-\u4DB5\u4E00-\u9FEF\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29]|[\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0])/;
    if (regex.test(temp)) {
      return true;
    }

    return false;
  }

  // 判断字符是否是中文符号
  static isChineseSymbol(temp) {
    const reg = /[\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]/;
    if (reg.test(temp)) {
      return true;
    }

    return false;
  }

  // 判断字符是否是英文半角符号
  static isEnSymbol(temp) {
    const reg = /[\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]/;
    if (reg.test(temp)) {
      return true;
    }

    return false;
  }

  // 判断字符长度
  static getStrLen(str) {
    let len = 0;
    const arr = str.split('');
    arr.forEach((char) => {
      if (Helper.isChinese(char) || Helper.isChineseSymbol(char)) {
        len += 1;
      } else {
        len += 0.5;
      }
    });

    return len;
  }

  static copyToClipboard(text) {
    const input = document.createElement('input');

    input.setAttribute('id', 'clipboard-input');
    input.setAttribute('type', 'text');
    input.value = text;
    document.body.append(input);

    const el = document.querySelector('#clipboard-input');
    el.select();
    el.setSelectionRange(0, 9999);
    document.execCommand('copy');
    document.body.removeChild(el);
  }

  static isInQQ() {
    const ua = navigator.userAgent.toLocaleLowerCase();
    if (/MicroMessenger/i.test(ua)) {
      return false;
    }

    return /QQ/i.test(ua);
  }

  // eslint-disable-next-line consistent-return
  static getParam(sParam) {
    const sPageURL = window.location.search.substring(1);
    const sURLVariables = sPageURL.split('&');
    let sParameterName;
    let i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
  }
}

export class Validator {
  static checkPhone(phone) {
    const regExp = /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/;

    if (!regExp.test(phone)) {
      return false;
    }

    return true;
  }

  static checkCode(code) {
    return (
      validator.isInt(code)
      && validator.isLength(code, {
        min: 6,
        max: 6,
      })
    );
  }

  static checkShortTitle(shortTitle, {
    min = 0,
    max = 10,
  }) {
    const len = Helper.getStrLen(shortTitle);
    return len <= max && len >= min;
  }

  static checkProductTag(tags) {
    const len = tags.split('#').filter(str => !!str).length;
    return len > 0 && len <= 3;
  }

  static checkJdGoodsUrl(url) {
    const whiteList = ['https://u.jd.com', 'https://item.jd.com'];
    return whiteList.some(item => url.trim().indexOf(item) === 0);
  }

  // 拼多多支持商品ID或商品URL
  static checkPddGoodsUrl(url) {
    if (/\d+/.test(url)) {
      return true;
    }

    const whiteList = ['https://mobile.yangkeduo.com'];
    return whiteList.some(item => url.trim().indexOf(item) === 0);
  }
}

export function getParseMaterialInfo(materialInfo) {
  let parseMaterialInfo;
  if (typeof materialInfo !== 'string') {
    return {};
  }

  try {
    parseMaterialInfo = JSON.parse(materialInfo);
  } catch (e) {
    parseMaterialInfo = {};
  }

  return parseMaterialInfo;
}

// 将价格参数转成分为单位  1,10 -> 100,1000
export const transformPrice = (price) => {
  if (!price) return '';

  const min = price.split(',')[0];
  const max = price.split(',')[1];

  if (!min && !max) {
    return '';
  }

  if (min && max) {
    return `${Number(min) * 100},${Number(max) * 100}`;
  }

  if (min && !max) {
    return `${Number(min) * 100},99999999`;
  }

  return `0,${Number(max) * 100}`;
};

export const transformCommisionRate = (commisionRate) => {
  if (!commisionRate) return '';

  const min = commisionRate.split(',')[0];
  const max = commisionRate.split(',')[1];

  if (min && max) {
    return `${min},${max}`;
  }

  if (min && !max) {
    return `${min},100`;
  }

  return `0,${max}`;
};

// 将不带协议url转换成带协议url
export const transformUrl = (url, schema = 'https') => {
  if (!url) return '';
  if (url.indexOf('http') !== -1) {
    return url;
  }

  return `${schema}://${url}`;
};

// 商品库存状态
export const getInventoryDesc = (item) => {
  let desc;
  switch (item.saas_type) {
    case 1:
      desc = item.inventory;
      break;
    case 2:
      desc = item.inventory > 0 ? '有货' : '无货';
      break;
    case 3:
      desc = item.inventory > 0 ? '有货' : '无货';
      break;
    default:
      break;
  }

  return desc;
};

// 时间戳转换
const toTimestamp = time => (Math.round(new Date(`${time} 00:00:00`).getTime() / 1000));

// 判断时间的区间，返回值是布尔值
export const timeLimit = (startTime, endTime, targetTime) => {
  const startTimeTimestamp = toTimestamp(startTime);
  const endTimeTimestamp = toTimestamp(endTime);
  const targetTimeTimestamp = toTimestamp(targetTime);
  return startTimeTimestamp <= targetTimeTimestamp && targetTimeTimestamp <= endTimeTimestamp;
};

// 判断字符是否为空的方法
export const isEmpty = (obj) => {
  if (typeof obj === 'undefined' || obj === null || obj === '') {
    return true;
  }

  return false;
};

// 金额转换，分转元

export const formatMoney = num => String((num / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
export const unformatMoney = num => accounting.unformat(num) * 100;

// utc时间转化为mm:dd hh:mm:ss
export const formatTime = (utcTime) => {
  const date = new Date(utcTime);
  const m = (`${date.getMonth() + 1}`).padStart(2, 0);
  const d = (`${date.getDate()}`).padStart(2, 0);
  const hh = (`${date.getHours()}`).padStart(2, 0);
  const mm = (`${date.getMinutes()}`).padStart(2, 0);
  const ss = (`${date.getSeconds()}`).padStart(2, 0);
  return `${m}-${d} ${hh}:${mm}:${ss}`;
};

// 计算直播时长
export const formatVisitTime = (start, end) => {
  const startTime = new Date(start);
  const endTime = new Date(end);
  const mss = Math.abs(startTime.getTime() - endTime.getTime());
  const hours = Math.floor(mss / (1000 * 60 * 60));
  const minutes = Math.floor((mss % (1000 * 60 * 60)) / (1000 * 60));
  return `${hours}小时${minutes}分钟`;
};

// 每三位添加一个','
export const splitNum = num => Number(num).toLocaleString();

// 判断超过4位数，单位改成万，并且保留两位小数
export const formatNum = (total, unit) => {
  let remain;
  let n = 0;
  let num = total;
  while (parseInt(num / 10000, 10)) {
    remain = num % 10000;
    num /= 10000;
    n++;
  }

  if (n === 0) return num + unit;
  let str = `${parseInt(num, 10)}.${remain.toString().slice(0, 2)}`;
  str = n === 1 ? `${str}万${unit}` : `${str}亿${unit}`;
  return str;
};
